import React from 'react'
import {useParams, useHistory} from 'react-router-dom'
import useEffect from 'admin/hooks/useEffect'
import usePaymentDetail from 'admin/hooks/usePaymentDetail'
import useDocument from 'admin/hooks/useDocument'
import useStateObject from 'admin/hooks/useStateObject'
import InputField from 'admin/components/shared/InputField'
import Modal from 'admin/components/shared/Modal'
import Header from '../shared/Header'
import useModal from '../../hooks/useModal'

export default () => {
  const history = useHistory()
  const {organisationID} = useParams()
  const {popModal} = useModal()
  const {paymentDetail, errors, create} = usePaymentDetail(organisationID)
  const [form, setForm, resetForm] = useStateObject(paymentDetail)

  useDocument({title: 'Add payment detail'})

  useEffect(() => setForm(paymentDetail), [paymentDetail], false)

  const handleCreate = e => {
    create(form, () => handleClose(e))
  }

  const handleClose = e => {
    e.preventDefault()
    resetForm(paymentDetail)
    popModal('new-payment-detail')
  }

  return (
    <Modal onClose={handleClose} flashId='new-payment-detail'>
      <Header title='Add payment detail'>
        <button className='button is-success' onClick={handleCreate}>
          Add
        </button>
      </Header>
      <section className='section'>
        <div className='container'>
          <InputField
            type='text'
            name='name'
            label='Name'
            value={form.name || ''}
            onChange={setForm}
            errors={errors.name}
          />
          <InputField
            type='textarea'
            name='contentWithPlaceholders'
            label='Content'
            value={form.contentWithPlaceholders || ''}
            onChange={setForm}
            errors={errors.contentWithPlaceholders}
            rows={6}
          />
        </div>
      </section>
    </Modal>
  )
}
